import { Button, Col, Form, Input, Modal, Row, Select, Space, theme } from "antd";
import React, { useEffect } from "react";
import { requiredItem, TYPE_MODAL } from "../../../constants/constants";
import { filterOption } from "../../../utils/funcHelper";
import { CloseOutlined, SaveOutlined } from "@ant-design/icons";
import { consoleLogUtil } from "../../../utils/consoleLogUtil";

const ModalWarehouseInfo = ({ visible, onCancel, onSave, data, title, type, lstBranches }) => {
    const [form] = Form.useForm();
    const { token } = theme.useToken();
    const formStyle = {
        maxWidth: 'none',
        background: token.colorFillAlter,
        borderRadius: token.borderRadiusLG,
        padding: 24,
    };
    const handleFinish = (values) => {
        if (type === "ADD") {
            onSave(values);
        } else {
            let tempData = { ...values };
            tempData.id = data.id;
            onSave(tempData);
        }
    };

    useEffect(() => {
        if (type === "EDIT") {
            form.setFieldsValue({
                name: data?.name,
                description: data?.description,
            });
        } else {
            form.resetFields();
        }
    }, [data, type, visible ]);

    useEffect(() => {
        if (type === TYPE_MODAL.EDIT && lstBranches.length > 0) {
            form.setFieldsValue({
                branch_id: parseInt(data?.branch_id)
            });
        }
        
    }, [visible, lstBranches])

    return (
        <Modal
            title={title}
            open={visible}
            onCancel={onCancel}
            width={'50%'}
            footer={null}
        >
            <Form form={form} layout="vertical" name="product-info-form" style={formStyle} onFinish={handleFinish}>
                <Row gutter={16}>
                    {/* Tên sản phẩm */}
                    <Col span={14}>
                        <Form.Item
                            label="Tên kho"
                            name="name"
                            rules={requiredItem}
                        >
                            <Input placeholder="Nhập tên kho" />
                        </Form.Item>
                    </Col>

                    {/* Chọn đơn vị tính */}
                    <Col span={10}>
                        <Form.Item
                            label="Chi nhánh"
                            name="branch_id"
                            rules={requiredItem}
                        >
                            <Select
                                showSearch
                                placeholder="Chọn chi nhánh"
                                filterOption={filterOption}
                                options={lstBranches}
                                style={{ width: '100%', height: 40 }}
                                disabled={type === TYPE_MODAL.EDIT}
                            />
                        </Form.Item>
                    </Col>

                    {/* Giá nhập */}
                    <Col span={24}>
                        <Form.Item
                            label="Ghi chú"
                            name="description"
                        >
                            <Input placeholder="Ghi chú"/>
                        </Form.Item>
                    </Col>

                </Row>

                <Row gutter={16} justify={'end'}>
                    <Space>
                        <Button onClick={onCancel} icon={<CloseOutlined />}>
                            Đóng
                        </Button>
                        <Button type="primary" htmlType="submit" icon={<SaveOutlined />}>
                            Lưu
                        </Button>
                    </Space>
                </Row>
            </Form>
        </Modal>
    );
};

export default React.memo(ModalWarehouseInfo);